import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GlobalSettings from './pages/GlobalSettings/GlobalSettings';
import Documents from './pages/Documents/Documents';
import DocumentTypes from './pages/DocumentTypes/DocumentTypes';
import Schemas from './pages/Schemas/Schemas';
import Tables from './pages/Tables/Tables';
import TableConfiguration from './pages/TableConfiguration/TableConfiguration';
import DatabaseStructure from './pages/DatabaseStructure/DatabaseStructure';
import AILLM from './pages/AILLM/AILLM';
import AgentConfigurations from './pages/AgentConfigurations/AgentConfigurations';
import AgentConfiguration from './pages/AgentConfiguration/AgentConfiguration';
import Chatbot from './pages/Chatbot/Chatbot';
import Nodes from './pages/Nodes/Nodes';
import Graphs from './pages/Graphs/Graphs';
import QueryHistory from './pages/QueryHistory/QueryHistory';
import ClarificationSchemas from './pages/ClarificationSchemas/ClarificationSchemas';
import ClarificationFields from './pages/ClarificationFields/ClarificationFields';
import OptionQueries from './pages/OptionQueries/OptionQueries';
import DecisionTrees from './pages/DecisionTrees/DecisionTrees';
import DecisionNodes from './pages/DecisionNodes/DecisionNodes';
import GuidedChatbot from './pages/GuidedChatbot/GuidedChatbot';
import ReactChatbot from './pages/ReactChatbot/ReactChatbot';
import ReactChatbotEmbed from './pages/ReactChatbotEmbed/ReactChatbotEmbed';
import ChatbotSections from './pages/ChatbotSections/ChatbotSections';
import ChatbotSectionConfig from './pages/ChatbotSectionConfig/ChatbotSectionConfig';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/global-settings"
          element={
            <ProtectedRoute>
              <GlobalSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents"
          element={
            <ProtectedRoute>
              <Documents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/document-types"
          element={
            <ProtectedRoute>
              <DocumentTypes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents-vectorized"
          element={
            <ProtectedRoute>
              <Documents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schemas"
          element={
            <ProtectedRoute>
              <Schemas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tables"
          element={
            <ProtectedRoute>
              <Tables />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tables/:tableId/configuration"
          element={
            <ProtectedRoute>
              <TableConfiguration />
            </ProtectedRoute>
          }
        />
        <Route
          path="/database-structure"
          element={
            <ProtectedRoute>
              <DatabaseStructure />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ai-llm"
          element={
            <ProtectedRoute>
              <AILLM />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent-configurations"
          element={
            <ProtectedRoute>
              <AgentConfigurations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent-configurations/:agentConfigId/configuration"
          element={
            <ProtectedRoute>
              <AgentConfiguration />
            </ProtectedRoute>
          }
        />
        <Route
          path="/nodes"
          element={
            <ProtectedRoute>
              <Nodes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/graphs"
          element={
            <ProtectedRoute>
              <Graphs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/query-history"
          element={
            <ProtectedRoute>
              <QueryHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clarification-schemas"
          element={
            <ProtectedRoute>
              <ClarificationSchemas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clarification-schemas/:schemaId/fields"
          element={
            <ProtectedRoute>
              <ClarificationFields />
            </ProtectedRoute>
          }
        />
        <Route
          path="/option-queries"
          element={
            <ProtectedRoute>
              <OptionQueries />
            </ProtectedRoute>
          }
        />
        <Route
          path="/decision-trees"
          element={
            <ProtectedRoute>
              <DecisionTrees />
            </ProtectedRoute>
          }
        />
        <Route
          path="/decision-trees/:treeKey/nodes"
          element={
            <ProtectedRoute>
              <DecisionNodes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chatbot"
          element={
            <ProtectedRoute>
              <Chatbot />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guided-chatbot"
          element={
            <ProtectedRoute>
              <GuidedChatbot />
            </ProtectedRoute>
          }
        />
        <Route
          path="/react-chatbot"
          element={
            <ProtectedRoute>
              <ReactChatbot />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chatbot-sections/:sectionId/configuration"
          element={
            <ProtectedRoute>
              <ChatbotSectionConfig />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chatbot-sections"
          element={
            <ProtectedRoute>
              <ChatbotSections />
            </ProtectedRoute>
          }
        />
        <Route path="/embed/react-chatbot" element={<ReactChatbotEmbed />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
